const API = {
  PRICE_LIST: "/web/v3/action/priceList/",
  CREATE_ORDRER: "/web/v3/action/order",
  GET_TRACK_STATUS: "/web/v3/action/trackNumber",
  GET_TRACK_STATUSES: "/web/v3/filter/parcelStatuses",
  BULK_BUY_FORM: "/web/v3/action/contact-form",
};

export default API;
